import list from "./list";
import create from "./create";
import market from "./market";
import crawlingMarket from "./crawling-market";
import sportEventMarket from "./sport-event-market";

const sportModule = {
  namespaced: true,
  modules: {
    list,
    create,
    market,
    "crawling-market": crawlingMarket,
    "sport-event-market": sportEventMarket,
  },
};

export default sportModule;
